import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

interface IProps {
  $isActive?: boolean
  $isHeader?: boolean
}

const getSelectedStyle = ({ $isActive, $isHeader }: IProps) => {
  if ($isHeader) {
    return css`
      padding: 6px 2px;
    `
  }
  if ($isActive) {
    return css`
      background: ${COLORS.primaryLight};
      border: 1px solid ${COLORS.primaryDark};
    `
  }
  return css`
    @media only screen and (min-width: ${MOBILE_SIZE_BREAKPOINT}px) {
      &:hover {
        background: ${COLORS.primaryLight};
        p {
          color: ${COLORS.secondaryDark};
        }
      }
    }
  `
}

export const TtsLanguageItemWrapper = styled.div<IProps>`
  position: relative;
  width: 100%;
  height: ${({ $isHeader }) => (!$isHeader ? '44px' : '100%')};
  padding: 6px;
  display: flex;
  align-items: center;
  gap: 10px;

  border-radius: 4px;
  ${getSelectedStyle}

  cursor: pointer;
  transition: all 0.3s;
`

export const LanguageItemCode = styled.span<IProps>`
  width: 24px;
  height: 24px;
  aspect-ratio: 1;
  border-radius: 6px;
  padding: 4px;
  background: ${COLORS.secondarySemiLight};

  color: ${COLORS.white};
  font-size: 12px;
  line-height: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`
